import { FieldValues, useFormContext, useWatch } from 'react-hook-form';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { ITERABLE_SMS } from '../../../../constants';
import { useCreateAccount } from '../../../../hooks';
import { useSendingPlatformsQueryContext } from '../../../../contexts';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { createIterableSmsPayload, getEspRadioOptionsForSendingPlatform } from '../../../../utils';
import { GreyBorderedContainer } from '../../styles';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';
import { AccountTypesRadioListField } from '../../Shared/AccountTypesRadioListField';

const { ESP, NAME, API_KEY, API_ENDPOINT } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const IterableSmsCreateModal = () => {
  const { createAccount } = useCreateAccount();
  const { espDefinitions = [] } = useSendingPlatformsQueryContext();

  const esp = useWatch({ name: ESP });
  const { trigger } = useFormContext();

  const onSubmit = (values: FieldValues) => {
    const payload = createIterableSmsPayload(values);
    createAccount(payload);
  };

  const espOptions = getEspRadioOptionsForSendingPlatform(ITERABLE_SMS, espDefinitions);

  return (
    <CreateModalRHF headerText="Connect Iterable SMS account" onSubmit={onSubmit}>
      <AccountTypesRadioListField
        name={ESP}
        labelText="Account type"
        options={espOptions}
        /**
         * Trigger is necessary to refresh the errors when the ESP is changed,
         * because the NAME and API_KEY are mapped to different names for each ESP.
         */
        onClick={() => trigger([NAME, API_KEY])}
      />
      <GreyBorderedContainer>
        {esp === SERVICE_PROVIDERS.TELNYX && (
          <>
            <ConnectedInputField name={NAME} labelText="Name" />
            <ConnectedInputField name={API_KEY} labelText="API key" />
          </>
        )}
        {esp === SERVICE_PROVIDERS.TWILIO && (
          <>
            <ConnectedInputField
              name={NAME}
              labelText="API key SID"
              placeholder="SKxxxxxxxxxxxxxxxx"
            />
            <ConnectedInputField name={API_KEY} labelText="API key secret" />
            <ConnectedInputField
              name={API_ENDPOINT}
              labelText="Account SID"
              placeholder="ACxxxxxxxxxxxxxxxx"
            />
          </>
        )}
      </GreyBorderedContainer>
    </CreateModalRHF>
  );
};
